import { render, staticRenderFns } from "./MapNavigationPlace.vue?vue&type=template&id=8a725642&"
import script from "./MapNavigationPlace.vue?vue&type=script&lang=js&"
export * from "./MapNavigationPlace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MapNavigationBackButton: require('/srv/rir-platform/tourism/src/tourism-front/components/common/MapNavigation/MapNavigationBackButton.vue').default,Favorite: require('/srv/rir-platform/tourism/src/tourism-front/components/common/Favorite/index.vue').default,ImageComponent: require('/srv/rir-platform/tourism/src/tourism-front/components/common/ImageComponent/index.vue').default,TopEntityRating: require('/srv/rir-platform/tourism/src/tourism-front/components/common/TopEntityRating/index.vue').default,Divider: require('/srv/rir-platform/tourism/src/tourism-front/components/common/Divider/index.vue').default,LinkMail: require('/srv/rir-platform/tourism/src/tourism-front/components/common/LinkMail/index.vue').default,LinkPhone: require('/srv/rir-platform/tourism/src/tourism-front/components/common/LinkPhone/index.vue').default,LinkSite: require('/srv/rir-platform/tourism/src/tourism-front/components/common/LinkSite/index.vue').default,Button: require('/srv/rir-platform/tourism/src/tourism-front/components/common/Button/index.vue').default})
